import { AppSettings } from '../../models/AppSettings';
import { datadogLogs, LogsInitConfiguration } from '@datadog/browser-logs';
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';

export const InitDatadogRum = async (appSettings: AppSettings) => {
  const site = appSettings.datadogConfig.site as RumInitConfiguration['site'];
  const traceContextInjection = appSettings.datadogConfig.traceContextInjection as RumInitConfiguration['traceContextInjection'];

  datadogRum.init({
    applicationId: appSettings.datadogConfig.applicationId,
    clientToken: appSettings.datadogConfig.clientToken,
    site: site,
    service: appSettings.datadogConfig.service,
    enableExperimentalFeatures: [appSettings.datadogConfig.enableExperimentalFeatures],
    env: appSettings.datadogConfig.env,
    sessionSampleRate: appSettings.datadogConfig.sessionSampleRate,
    sessionReplaySampleRate: appSettings.datadogConfig.sessionReplaySampleRate,
    traceSampleRate: appSettings.datadogConfig.traceSampleRate,
    traceContextInjection: traceContextInjection,
    trackUserInteractions: appSettings.datadogConfig.trackUserInteractions,
    trackResources: appSettings.datadogConfig.trackResources,
    trackLongTasks: appSettings.datadogConfig.trackLongTasks,
    defaultPrivacyLevel: appSettings.datadogConfig.defaultPrivacyLevel,
    version: appSettings.datadogConfig.version,
    remoteConfiguration: {
      id: appSettings.datadogConfig.remoteConfigurationId
    }
  });

  datadogRum.startSessionReplayRecording();
};

export const InitDatadogLogs = async (appSettings: AppSettings) => {
  const site = appSettings.datadogConfig.site as LogsInitConfiguration['site'];

  datadogLogs.init({
    clientToken: appSettings.datadogConfig.clientToken,
    site: site,
    service: appSettings.datadogConfig.service,
    env: appSettings.datadogConfig.env,
    version: appSettings.datadogConfig.version,
    sessionSampleRate: appSettings.datadogConfig.sessionSampleRate,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['warn', 'error'],
    storeContextsAcrossPages: true,
  });
};